import {
  Card,
  CardContent,
  Stack,
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from '@mui/material';
import { AccountBalanceWallet, Add, Refresh } from '@mui/icons-material';
import { themeColors } from '../../../theme/theme';
import { useTranslation } from '@/kit/useTranslation';

export default function AvailableBalanceCard({ balance, onAddMoney, loading, onRefresh }) {
  const { t } = useTranslation();
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
      }}
    >
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <AccountBalanceWallet sx={{ fontSize: 20 }} />
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {t('payment.wallet.availableBalance')}
              </Typography>
            </Stack>
            <Typography variant="h4" fontWeight={700}>
              ₹{balance || 0}
            </Typography>
          </Box>
          <IconButton
            size="small"
            sx={{
              color: 'white',
              transition: 'transform 0.3s',
              '&:hover': {
                transform: 'rotate(180deg)',
              },
            }}
            onClick={onRefresh}
          >
            <Refresh />
          </IconButton>
        </Stack>
        {/* Comming soon: Add balance feature disabled as per request */}
        {/* <Button
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <Add />}
          onClick={onAddMoney}
          disabled={loading}
          sx={{
            mt: 2,
            bgcolor: 'white',
            color: themeColors.primaryColor,
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': {
              bgcolor: '#f5f5f5',
            },
          }}
          fullWidth
        >
          {loading ? t('payment.processing') : t('payment.wallet.addMoney')}
        </Button> */}
      </CardContent>
    </Card>
  );
}
